import { ClaimProcessingStatus } from "../../../types/ediConversionFile";

// "held" is an upload status (CLE-2921), not a claim-processing one, but it replaces the claim
// status in the label: a held file's stages sit at their 'pending' defaults, and "Pending" would
// suggest work is queued when nothing will happen until someone processes it.
export type EdiFileDisplayStatus = ClaimProcessingStatus | "held";

const VISUAL: Record<
  EdiFileDisplayStatus,
  { icon: string; color: string; text: string }
> = {
  pending: { icon: "pi pi-clock", color: "#6c757d", text: "Pending" },
  processing: { icon: "pi pi-clock", color: "#007bff", text: "Processing" },
  completed: {
    icon: "pi pi-check-circle",
    color: "#28a745",
    text: "Completed",
  },
  failed: { icon: "pi pi-times-circle", color: "#dc3545", text: "Failed" },
  skipped: { icon: "pi pi-minus-circle", color: "#6c757d", text: "Skipped" },
  held: { icon: "pi pi-pause", color: "#6c757d", text: "On hold" },
};

const NONE = { icon: "pi pi-minus", color: "#6c757d", text: "—" };

interface IEdiFileStatusLabelProps {
  status: EdiFileDisplayStatus | null | undefined;
}

// Icon + text status used by the 835 Conversion Files table and the split pieces list.
function EdiFileStatusLabel({ status }: IEdiFileStatusLabelProps) {
  const v = status ? VISUAL[status] : NONE;
  return (
    <span
      style={{
        color: v.color,
        display: "inline-flex",
        alignItems: "center",
        gap: "0.4rem",
        whiteSpace: "nowrap",
      }}
    >
      <i className={v.icon} />
      {v.text}
    </span>
  );
}

export default EdiFileStatusLabel;
